import React from "react";
import { Play, Pause } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";

export default function AudioCard({ audio, queue }) {
  const { current, playing, togglePlay, playTrack } = usePlayer();
  const isThis = current?.id === audio.id;

  const onClick = () => {
    if (isThis) togglePlay();
    else playTrack(audio, queue || [audio]);
  };

  return (
    <div
      data-testid={`audio-card-${audio.id}`}
      className="group bg-[#141414] border border-[#2a2a2a] hover:border-[#ff4500]/50 transition-colors duration-200 rounded-sm overflow-hidden"
    >
      <div className="relative aspect-square bg-[#1a1a1a]">
        {audio.cover_url ? (
          <img src={audio.cover_url} alt={audio.title} className="w-full h-full object-cover" />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="font-display text-6xl text-[#ff4500]/30">♪</div>
          </div>
        )}
        <button
          onClick={onClick}
          data-testid={`audio-play-${audio.id}`}
          className="absolute bottom-3 right-3 w-12 h-12 bg-[#ff4500] hover:bg-[#ff5722] flex items-center justify-center transition-colors shadow-2xl translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 duration-200"
        >
          {isThis && playing ? <Pause className="w-5 h-5 text-white" /> : <Play className="w-5 h-5 text-white ml-0.5" />}
        </button>
        {isThis && playing && (
          <div className="absolute top-3 left-3 flex items-end h-4">
            <span className="sound-bar" /><span className="sound-bar" /><span className="sound-bar" /><span className="sound-bar" />
          </div>
        )}
      </div>
      <div className="p-3">
        <div className="font-display text-sm truncate">{audio.title}</div>
        <div className="text-xs text-[#a3a3a3] truncate mt-1">{audio.artist}</div>
      </div>
    </div>
  );
}
